import React from 'react';
import './AccessDenied.css'; // Import the CSS
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { useNavigate } from 'react-router-dom';

const AccessDenied = ({onSignout}) => {
const { showAlert } = useCustomContext();
 const navigate = useNavigate();

   const Logout = () => {
       // Keys to keep
       const keysToKeep = ['rememberMe', 'rememberedEmail', 'rememberedPassword'];
   
       showAlert('Are you sure you want to logout?', [
         {
           label: 'Yes',
           onClick: async () => {
             Object.keys(localStorage).forEach((key) => {
               if (!keysToKeep.includes(key)) {
                 localStorage.removeItem(key);
               }
             });
   
             try {
            
               onSignout();     // Call sign out after logging is done
               navigate('/');   // Redirect after signout
             } catch (error) {
               console.error('Failed to insert logout log:', error);
               showAlert('Logout log failed. Still signing out for safety.', [
                 { label: 'Ok', color: 'var(--buttonColor)' }
               ]);
               onSignout();
               navigate('/');
             }
           },
           color: 'var(--buttonColor)', // Set button color
         },
         {
           label: 'No',
           onClick: () => {
             // console.log('User cancelled logout');
           },
           color: 'gray', // Set button color
         }
       ]);
   
     };
  return (
    <div className="access-denied-container">
      <img
        src="/access-denied.png" // Place the image in the public/ folder
        alt="Access Denied"
        className="access-denied-image"
      />
      <h2 className="access-denied-heading">Currently, you don't have permissions</h2>
      <p className="access-denied-text">
        Please contact your administrator to request access.
      </p>
      <button className="access-denied-button" onClick={Logout} >Log Out</button>
    </div>
  );
};

export default AccessDenied;
